const generateUuid = (): string => {
    const cryptoProvider = window.crypto || (window as Window & { msCrypto?: Crypto }).msCrypto;

    if (cryptoProvider?.randomUUID) {
        return cryptoProvider.randomUUID();
    }

    if (cryptoProvider?.getRandomValues) {
        const bytes = new Uint8Array(16);

        cryptoProvider.getRandomValues(bytes);

        bytes[6] = (bytes[6] % 16) + 64;
        bytes[8] = (bytes[8] % 64) + 128;

        let hex = '';

        for (let i = 0; i < bytes.length; i++) {
            hex += bytes[i].toString(16).padStart(2, '0');
        }

        return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
        const random = Math.floor(Math.random() * 16);
        const value = char === 'x' ? random : (random % 4) + 8;

        return value.toString(16);
    });
};

export default generateUuid;
